var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 66,
    viewBox: "0 0 256 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.32 0H15.68C7.02017 0 0 7.02017 0 15.68V50.32C0 58.9798 7.02017 66 15.68 66H240.32C248.98 66 256 58.9798 256 50.32V15.68C256 7.02017 248.98 0 240.32 0Z",
    fill: "#F83B53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.42 35H251.12L231.42 60H211.72L231.42 35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.99 31L213.86 8H230.85L248.98 31H231.99ZM231.42 32L211.72 7H231.42L251.12 32H231.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3801 32.39C13.3801 27.49 16.4801 24.64 20.4401 24.64C22.3101 24.64 23.8501 25.54 24.8501 26.52L23.0101 28.59C22.3001 27.94 21.5101 27.53 20.4401 27.53C18.3401 27.53 16.8101 29.31 16.8101 32.28C16.8101 35.25 18.3401 37.08 20.5701 37.08C21.6401 37.08 22.5201 36.56 23.2301 35.77L25.0701 37.79C23.8601 39.22 22.2101 39.96 20.2201 39.96C16.5401 39.96 13.3701 37.36 13.3701 32.38L13.3801 32.39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8501 32.24C26.8501 27.3 29.2701 24.64 32.8001 24.64C36.3301 24.64 38.7501 27.3 38.7501 32.24C38.7501 37.18 36.3301 39.97 32.8001 39.97C29.2701 39.97 26.8501 37.29 26.8501 32.24ZM35.3101 32.24C35.3101 29.17 34.3401 27.53 32.7901 27.53C31.2401 27.53 30.2701 29.16 30.2701 32.24C30.2701 35.32 31.2401 37.08 32.7901 37.08C34.3401 37.08 35.3101 35.43 35.3101 32.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3301 24.91H44.7601L47.8701 32.26L49.1401 35.51H49.2201C49.0701 33.95 48.7601 31.88 48.7601 30.14V24.91H51.9501V39.7H48.5201L45.4101 32.33L44.1401 29.1H44.0601C44.2101 30.73 44.5201 32.72 44.5201 34.46V39.71H41.3301V24.92V24.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1699 24.91H58.5999L61.7099 32.26L62.9799 35.51H63.0599C62.9099 33.95 62.5999 31.88 62.5999 30.14V24.91H65.7899V39.7H62.3599L59.2499 32.33L57.9799 29.1H57.8999C58.0499 30.73 58.3599 32.72 58.3599 34.46V39.71H55.1699V24.92V24.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6001 24.91H79.4001V27.72H72.9501V30.69H78.4301V33.5H72.9501V36.9H79.6301V39.71H69.6001V24.92V24.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5701 32.39C82.5701 27.49 85.6701 24.64 89.6301 24.64C91.5001 24.64 93.0401 25.54 94.0401 26.52L92.2001 28.59C91.4901 27.94 90.7001 27.53 89.6301 27.53C87.5301 27.53 86.0001 29.31 86.0001 32.28C86.0001 35.25 87.5301 37.08 89.7601 37.08C90.8301 37.08 91.7101 36.56 92.4201 35.77L94.2601 37.79C93.0501 39.22 91.4001 39.96 89.4101 39.96C85.7301 39.96 82.5601 37.36 82.5601 32.38L82.5701 32.39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.32 27.72H95.8901V24.91H108.1V27.72H103.67V39.7H100.32V27.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.96 24.91H126.44L126.87 32.78C126.91 34.04 126.93 35.16 126.95 36.49H127.03C127.24 35.16 127.51 34.03 127.76 32.79L128.75 28.66H130.89L131.82 32.79C132.06 34 132.32 35.13 132.55 36.49H132.64C132.67 35.13 132.68 34.01 132.72 32.79L133.14 24.91H136.39L134.56 39.7H130.99L130.11 35.12C129.93 34.18 129.77 33.19 129.71 32.3H129.64C129.55 33.19 129.43 34.18 129.25 35.12L128.4 39.7H124.91L122.95 24.91H122.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.5 24.91H145.51L150.12 39.7H146.57L144.66 32.21C144.28 30.73 143.83 29 143.48 27.44H143.39C143.03 29 142.62 30.73 142.24 32.21L140.32 39.7H136.9L141.5 24.91ZM139.94 33.57H147.02V36.18H139.94V33.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.95 24.91H156.29V36.89H162.87V39.7H152.95V24.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.79 24.91H170.13V36.89H176.71V39.7H166.79V24.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.31 24.91H190.11V27.72H183.66V30.69H189.14V33.5H183.66V36.9H190.34V39.71H180.31V24.92V24.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.18 27.72H192.75V24.91H204.96V27.72H200.53V39.7H197.18V27.72Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.477e09559e7339d0b0cc8acdeac5f488.svg";
export { ForwardRef as ReactComponent };